class ZRPopper {
  myOptions = {};

  constructor(elBase, elCallout, myOptions) {
    this.elBase = elBase;
    this.elBaseRect = null;
    this.elCallout = elCallout;
    this.elCalloutRect = null;
    this.myOptions = myOptions;
  }

  show() {
    this.elCallout.style.opacity = 0; // hide callout while positioning it
    this.elCallout.style.position = 'fixed';
    this.elCallout.style.display = 'block';

    // wait to do this in case of a scroll
    this.elBaseRect = this.elBase.getBoundingClientRect();
    // wait to do this until after positioning and displaying the block to avoid an empty rect
    this.elCalloutRect = this.elCallout.getBoundingClientRect();

    const { placement } = this.myOptions;
    let { elCalloutTop, elCalloutLeft, elArrowTop, elArrowLeft } = this.calcCalloutPosition(placement);

    const actualPlacement = this.maybeFlipPlacement(placement, elCalloutTop, elCalloutLeft, elArrowTop, elArrowLeft);
    if (actualPlacement !== placement) {
      const flippedCalloutPosition = this.calcCalloutPosition(actualPlacement);
      elCalloutTop = flippedCalloutPosition.elCalloutTop;
      elCalloutLeft = flippedCalloutPosition.elCalloutLeft;
      elArrowTop = flippedCalloutPosition.elArrowTop;
      elArrowLeft = flippedCalloutPosition.elArrowLeft;
    }
    this.elCallout.setAttribute('x-placement', actualPlacement);

    // TODO jj: handle other options

    this.elCallout.style.top = `${elCalloutTop}px`;
    this.elCallout.style.left = `${elCalloutLeft}px`;

    const elArrow = this.elCallout.querySelector('.arrow');
    elArrow.style.top = `${elArrowTop}px`;
    elArrow.style.left = `${elArrowLeft}px`;
    this.elCallout.style.removeProperty('opacity'); // unhide callout once done positioning
  }

  calcCalloutPosition(placement) {
    let elCalloutTop;
    let elCalloutLeft;
    let elArrowTop;
    let elArrowLeft;
    const ARROW_LEFT_OFFSET_PX = 105;
    const ARROW_TOP_OFFSET_PX = 25;

    switch (placement) {
      case 'bottom-left':
        // not yet implemented
        break;
      case 'bottom':
        elCalloutTop = this.elBaseRect.bottom;
        elCalloutLeft = this.horizontallyCenterCalloutWithRespectToBase();
        elArrowLeft = ARROW_LEFT_OFFSET_PX;
        break;
      case 'bottom-right':
        // not yet implemented
        break;
      case 'top-left':
        // not yet implemented
        break;
      case 'top':
        elCalloutTop = this.elBaseRect.top - this.elCalloutRect.height;
        elCalloutLeft = this.horizontallyCenterCalloutWithRespectToBase();
        elArrowLeft = ARROW_LEFT_OFFSET_PX;
        break;
      case 'top-right':
        // not yet implemented
        break;
      case 'left': // vertically center
        elCalloutTop = this.vericallyCenterCalloutWithRespectToBase();
        elCalloutLeft = this.elBaseRect.left - this.elCalloutRect.width;
        elArrowLeft = ARROW_TOP_OFFSET_PX;
        break;
      case 'right': // vertically center
        elCalloutTop = this.vericallyCenterCalloutWithRespectToBase();
        elCalloutLeft = this.elBaseRect.left + this.elBaseRect.width;
        elArrowLeft = ARROW_TOP_OFFSET_PX;
        break;
      default:
        elCalloutTop = this.elBaseRect.bottom;
        elCalloutLeft = this.elBaseRect.left;
    }

    return { elCalloutTop, elCalloutLeft, elArrowTop, elArrowLeft };
  }

  maybeFlipPlacement(placement, elCalloutTop, elCalloutLeft) {
    const { clientHeight, clientWidth } = document.body;
    let pxCalloutChoppedBelow;
    let pxCalloutChoppedAbove;
    let pxCalloutChoppedLeft;
    let pxCalloutChoppedRight;
    let flipPlacement = placement;

    switch (placement) {
      case 'top':
        pxCalloutChoppedAbove = this.elCalloutRect.height - this.elBaseRect.top;
        pxCalloutChoppedBelow = elCalloutTop + this.elCalloutRect.height - clientHeight;
        if (pxCalloutChoppedAbove > 0 && pxCalloutChoppedAbove > pxCalloutChoppedBelow) {
          flipPlacement = 'bottom';
        }
        break;
      case 'bottom':
        pxCalloutChoppedBelow = elCalloutTop + this.elCalloutRect.height - clientHeight;
        pxCalloutChoppedAbove = this.elCalloutRect.height - this.elBaseRect.top;
        if (pxCalloutChoppedBelow > 0 && pxCalloutChoppedBelow > pxCalloutChoppedAbove) {
          flipPlacement = 'top';
        }
        break;
      case 'left':
        pxCalloutChoppedLeft = this.elCalloutRect.width - this.elBaseRect.left;
        pxCalloutChoppedRight = elCalloutLeft + this.elCalloutRect.width - clientWidth;
        if (pxCalloutChoppedLeft > 0 && pxCalloutChoppedLeft > pxCalloutChoppedRight) {
          flipPlacement = 'right';
        }
        break;
      case 'right':
        pxCalloutChoppedLeft = this.elCalloutRect.width - this.elBaseRect.left;
        pxCalloutChoppedRight = elCalloutLeft + this.elCalloutRect.width - clientWidth;
        if (pxCalloutChoppedRight > 0 && pxCalloutChoppedRight > pxCalloutChoppedLeft) {
          flipPlacement = 'left';
        }
        break;
      default:
        // noop
    }
    return flipPlacement;
  }

  horizontallyCenterCalloutWithRespectToBase() {
    const offset = (this.elBaseRect.width - this.elCalloutRect.width) / 2;
    return this.elBaseRect.left + offset;
  }

  vericallyCenterCalloutWithRespectToBase() {
    const offset = (this.elBaseRect.height - this.elCalloutRect.height) / 2;
    return this.elBaseRect.top + offset;
  }

  update() {
    this.show();
  }
}

export default ZRPopper;
